import { render, staticRenderFns } from "./mutasi.vue?vue&type=template&id=fbf685e6"
import script from "./mutasi.vue?vue&type=script&lang=js"
export * from "./mutasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports